

function isAbTestBlocked() {
  try {
    const popupSettings = window.ShopifyContext?.popup || {};
    console.log('[isAbTestBlocked]', popupSettings.enable_variant_trigger);
    return !!popupSettings.enable_variant_trigger;
  } catch (e) {
    return false;
  }
}
 
 class SiloFooterStickyBar {
  constructor(options = {}) {

    this.stickyBar = document.getElementById(options.stickyBarId || 'sticky-submit');
    this.stickyBtn = document.getElementById(options.stickyBtnId || 'sticky-add-to-cart');
    this.form = document.querySelector(options.formSelector || '[data-type="add-to-cart-form"]');
    this.header = document.getElementById(options.headerId || 'header-container');
    this.bundleNameEl = document.getElementById(options.bundleNameElId || 'bundle-name-text');
    this.footer = document.getElementById(options.footerId || 'footer');

    this.bundleMap = options.bundleMap || {
      "51761666425128": "Base only - White",
       "51761666294056": "Base only - Black",
      '51761666457896': 'Basic Set (4pcs) - White',
      '51761666490664': 'Essentials Set (8pcs) - White',
      '51761666523432': 'Extended Set (12pcs) - White',
      '51761666326824': 'Basic Set (4pcs) - Black',
      '51761666359592': 'Essentials Set (8pcs) - Black',
      '51761666392360': 'Extended Set (12pcs) - Black'
    };

    this.lastVariant = null;
    this.updateInterval = null;

    this.boundToggleStickyBar = this.toggleStickyBar.bind(this);
    this.boundUpdateBundleName = this.updateBundleName.bind(this);
    this.boundOnStickyBtnClick = this.onStickyBtnClick.bind(this);

    this.init();
  }



init() {
  if (!this.stickyBar || !this.stickyBtn) {
    console.warn('[StickyBar] Missing essential elements');
    return;
  }

  if (window.location.pathname === '/pages/overview') {
    const firstAncor = document.getElementById('includedPerks');
    if (firstAncor) {
      this.initFirstAncorObserver(firstAncor);
    }
  }

  this.toggleStickyBar();
  this.updateBundleName();

  window.addEventListener('scroll', this.boundToggleStickyBar);
  window.addEventListener('resize', this.boundToggleStickyBar);
  this.updateInterval = setInterval(this.boundUpdateBundleName, 300);
  this.stickyBtn.addEventListener('click', this.boundOnStickyBtnClick);
}


  updateBundleName() {
    const params = new URLSearchParams(window.location.search);
    const currentVariant = params.get('variant');
    if (currentVariant !== this.lastVariant) {
      this.lastVariant = currentVariant;
      const bundleName = this.bundleMap[currentVariant] || '';
      if (this.bundleNameEl) {
        this.bundleNameEl.textContent = bundleName;
      }
    }
  }

  isInViewport(el) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

initFirstAncorObserver(firstAncor) {
  let activated = false;

  this.firstAncorObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (!activated && entry.isIntersecting && entry.intersectionRatio >= 0.2) {
        console.log('[StickyBar] firstAncor reached 20% — activating');
        this.stickyBar.classList.add('visible');
        activated = true;
        this.firstAncorObserver.disconnect();
      }
    });
  }, {
    threshold: Array.from({ length: 100 }, (_, i) => i / 100)
  });

  this.firstAncorObserver.observe(firstAncor);
}


toggleStickyBar() {
  if (window.siloStickyBarForceHide || !this.stickyBar || !this.stickyBtn) {
    return this.stickyBar.classList.remove('visible');
  }

  if (window.location.pathname === '/pages/overview' && this.firstAncorObserver) {
    return; 
  }

  const footerVisible = this.footer && this.isInViewport(this.footer);
  if (footerVisible) {
    this.stickyBar.classList.remove('visible');
    return;
  }

  if (this.form) {
    const formBottom = this.form.getBoundingClientRect().bottom;
    if (formBottom < window.innerHeight / 2 && !footerVisible) {
      this.stickyBar.classList.add('visible');
      if (this.header) {
        const productPgaeAnnou = document.querySelector(".productPgaeAnnou")
        productPgaeAnnou.style.visibility = 'hidden';
        productPgaeAnnou.style.opacity = '0';
        productPgaeAnnou.style.pointerEvents = 'none';
        this.header.style.visibility = 'hidden';
        this.header.style.opacity = '0';
        this.header.style.pointerEvents = 'none';
      }
      return;
    }
  }

  this.stickyBar.classList.remove('visible');
  if (this.header) {
           const productPgaeAnnou = document.querySelector(".productPgaeAnnou")
        productPgaeAnnou.style.visibility = 'visible';
        productPgaeAnnou.style.opacity = '1';
        productPgaeAnnou.style.pointerEvents = 'auto';
    this.header.style.visibility = 'visible';
    this.header.style.opacity = '1';
    this.header.style.pointerEvents = 'auto';
  }
}




  onStickyBtnClick(e) {
  const hasParams = window.location.search && window.location.search !== '?';
  const hash = window.location.hash;

  if (hash === '#video' || hash === '#firstAncor') {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });

    const alreadySubmitted = localStorage.getItem('popupFormSubmit') === 'true';

    if (
      !alreadySubmitted &&
      window.siloPopupManager &&
      !window.siloPopupManager.isFormSubmitted?.()
    ) {
      if (!isAbTestBlocked()) {
        setTimeout(() => {
          window.siloPopupManager.open(); 
        }, 2000);
      } else {
        console.warn('[StickyBar] Popup blocked by AB test/variant setting');
      }
    } else if (alreadySubmitted) {
      console.log('[StickyBar] Popup not opened — form already submitted');
    }
    return;
  }

  const submitBtn = this.form?.querySelector('button[type="submit"]');
  if (submitBtn) submitBtn.click();
}


  tryOpenPopup() {
    if (
      typeof window.siloPopupManager !== "undefined" &&
      window.siloPopupManager &&
      typeof window.siloPopupManager.isFormSubmitted === "function" &&
      !window.siloPopupManager.isFormSubmitted() &&
      !isAbTestBlocked()
    ) {
      window.siloPopupManager.open();
      return true;
    }
    return false;
  }

  destroy() {
    window.removeEventListener('scroll', this.boundToggleStickyBar);
    window.removeEventListener('resize', this.boundToggleStickyBar);
    clearInterval(this.updateInterval);
    if (this.stickyBtn) {
      this.stickyBtn.removeEventListener('click', this.boundOnStickyBtnClick);
    }
  }
}



